import { Api, Codes } from 'api';
export default {
  state: {
    placeData: {},
    /**
     *  学生 申请表
     * curStep 当前 timeline
     * step1 -- 申请说明 step2 -- 个人信息 step3 -- 学业信息 step4 -- 活动奖项 step5 -- 作文 step6 -- 预约面试时间 step7 -- 预览及提交
     * timeLineData ---- 左侧 时间轴tab
     * formDataStatus ----- 全部表单数据 状态
     */
    applicationData: {
      curStep: 1,
      timeLineData: null,
      formData: null,
      submitData: null,
      linkData: {
        intro: 1,
        personal: 2,
        academic: 3,
        awards: 4,
        essays: 5,
        interview: 6,
        review: 7
      }
    },
    clubData: {},
    successCardStatus: {}
  },
  getters: {
    isClubUser: state => {
      return !!state.clubData?.club?.id;
    },
    /************ 学生申请 *************/
    /**
     * @description 获取申请表 当前step
     * @param {*} state
     */
    getApplicationCurStep: state => {
      return state.applicationData.curStep;
    },
    /**
     * @description 获取申请表 数据
     * @param {*} state
     */
    getApplicationFormData: state => {
      return state.applicationData.formData;
    },
    /**
     *  返回 未完成 的表单数据
     * @param {*} state
     */
    getApplicationReviewData: state => {
      let result = [];
      state.applicationData.formData.map((item, index) => {
        if (item.error) {
          let temp = JSON.parse(JSON.stringify(item));
          temp.data = [];
          item.data.map(item_sec => {
            let temp_sec = JSON.parse(JSON.stringify(item_sec));
            temp_sec.msgArr = [];
            item_sec.msgArr.map(item_thr => {
              if (item_thr.error) {
                let temp_thr = JSON.parse(JSON.stringify(item_thr));
                temp_sec.msgArr.push(temp_thr);
              }
            });
            if (temp_sec.msgArr.length !== 0) temp.data.push(temp_sec);
          });
          if (index !== state.applicationData.formData.length - 1) result.push(temp);
        }
      });
      return result;
    }
  },
  mutations: {
    setClubData: (state, payload) => {
      if (payload.promise) {
        state.clubData = payload.promise;
      } else {
        state.clubData = payload?.data || {};
      }
    },
    setPlaceData: (state, payload) => {
      if (payload.promise) {
        state.placeData = payload.promise;
      } else {
        state.placeData = payload?.data || {};
      }
    },
    /**
     * 设置 学生申请 timeline step
     * @param {*} state vuex state
     * @param {*} steps
     */
    setApplicationTimeLine: (state, steps) => {
      state.applicationData.curStep = steps;
    },
    /**
     * 设置 学生申请表 formData submitData 数据
     * @param {*} state
     * @param {*} formData 表单状态
     * @param {*} submitData 提交数据
     */
    setApplicationFormData: (state, applicationData) => {
      state.applicationData.formData = applicationData.formData;
      state.applicationData.submitData = applicationData.submitData;
    },
    /**
     * 修改申请表 状态 数据 success wrong
     * @param {*} state
     * @param {*} stepStatus 时间轴状态
     * stepStatus :{index: 下标 必填 其余字段 }
     */
    changeApplicationFormDataStatus: (state, stepStatus) => {
      for (const key in stepStatus) {
        if (key !== 'index') {
          const item = stepStatus[key];
          state.applicationData.formData[stepStatus.index][key] = item;
        }
      }
    },
    /**
     * @description 修改 提交数据表单
     * @function
     * @param {*}
     * @return {*}
     */
    changeApplicationSubmitForm: (state, stepData) => {
      for (const key in stepData) {
        const item = stepData[key];
        state.applicationData.submitData[key] = item;
      }
    },
    setSuccessCardStatus: (state, payload) => {
      if (payload.promise) {
        state.successCardStatus = payload.promise;
      } else {
        state.successCardStatus = payload?.data || {};
      }
    }
  },
  actions: {
    getStudentClubData: ({ commit, state }) => {
      let memory = state.clubData;
      if (memory instanceof Promise) {
        return memory;
      } else {
        if (Object.keys(state.clubData).length) {
          return new Promise(resolve => {
            resolve(state.clubData);
          });
        } else {
          let promise = new Promise(resolve => {
            let ret = {};
            if (Object.keys(state.clubData).length) {
              resolve(state.clubData);
            } else {
              Api.get.getStudentClubMy().then(res => {
                if (res.status === Codes.SUCCESS) {
                  ret = res.data;
                  commit('setClubData', { data: ret });
                  resolve(ret);
                } else {
                  resolve(ret);
                }
              });
            }
          });
          commit('setClubData', { promise });
          return promise;
        }
      }
    },
    getStudentPlaceData: ({ commit, state }, payload = {}) => {
      const force = Boolean(payload?.force);
      if (force) {
        let promise = new Promise(resolve => {
          let ret = {};
          Api.get.getStudentCourseSurveyPlace().then(res => {
            if (res.status === Codes.SUCCESS) {
              ret = res.data;
              commit('setPlaceData', { data: ret });
            }
            resolve(ret);
          });
        });
        commit('setPlaceData', { promise });
        return promise;
      }

      let memory = state.placeData;
      if (memory instanceof Promise) {
        return memory;
      } else {
        if (Object.keys(state.placeData).length) {
          return new Promise(resolve => {
            resolve(state.placeData);
          });
        } else {
          let promise = new Promise(resolve => {
            let ret = {};
            if (Object.keys(state.placeData).length) {
              resolve(state.placeData);
            } else {
              Api.get.getStudentCourseSurveyPlace().then(res => {
                if (res.status === Codes.SUCCESS) {
                  ret = res.data;
                  commit('setPlaceData', { data: ret });
                  resolve(ret);
                } else {
                  resolve(ret);
                }
              });
            }
          });
          commit('setPlaceData', { promise });
          return promise;
        }
      }
    },
    /**
     * @description 跳转 学生申请 timeline step
     * @function
     * @param {*} steps
     */
    setApplicationTimeLine: ({ commit }, steps) => {
      commit('setApplicationTimeLine', steps);
    },

    // 修改 学生申请 timelINE 状态数据
    changeApplicationFormDataStatus: ({ commit }, stepStatus) => {
      commit('changeApplicationFormDataStatus', stepStatus);
    },
    // 设置 学生申请 表单数据
    setApplicationFormData: ({ commit }, formData) => {
      commit('setApplicationFormData', formData);
    },
    // 修改 submitData 表单数据
    changeApplicationSubmitForm: ({ commit }, formData) => {
      commit('changeApplicationSubmitForm', formData);
    },
    getStudentSuccessCardStatus: ({ commit, state }, payload = {}) => {
      const force = Boolean(payload?.force);
      if (force) {
        let promise = new Promise(resolve => {
          let ret = {};
          Api.get.getStudentSuccessCardStatus().then(res => {
            if (res.status === Codes.SUCCESS) {
              ret = res.data;
              commit('setSuccessCardStatus', { data: ret });
            }
            resolve(ret);
          });
        });
        commit('setSuccessCardStatus', { promise });
        return promise;
      }

      let memory = state.successCardStatus;
      if (memory instanceof Promise) {
        return memory;
      } else {
        if (state.successCardStatus && Object.keys(state.successCardStatus).length) {
          return new Promise(resolve => {
            resolve(state.successCardStatus);
          });
        } else {
          let promise = new Promise(resolve => {
            let ret = {};
            if (state.successCardStatus && Object.keys(state.successCardStatus).length) {
              resolve(state.successCardStatus);
            } else {
              Api.get.getStudentSuccessCardStatus().then(res => {
                if (res.status === Codes.SUCCESS) {
                  ret = res.data;
                  commit('setSuccessCardStatus', { data: ret });
                  resolve(ret);
                } else {
                  resolve(ret);
                }
              });
            }
          });
          commit('setSuccessCardStatus', { promise });
          return promise;
        }
      }
    }
  }
};
